module.exports = __webpack_public_path__ + "static/media/codebg2.e2a40b25.jpg";